/**
 * Prefer exact coordinates when building Google Maps URLs so the pin matches
 * map/GPS placement. Address-only search lets Google resolve text to a centroid,
 * which is often wrong for map drops or approximate reverse-geocoded addresses.
 */

import { isUnknownLocationValue } from "@/features/homeowners/lib/unknown-location"

export function isValidLatLngPair(lat: unknown, lng: unknown): boolean {
  const nLat = typeof lat === "string" ? parseFloat(lat) : Number(lat)
  const nLng = typeof lng === "string" ? parseFloat(lng) : Number(lng)
  return Number.isFinite(nLat) && Number.isFinite(nLng)
}

export function buildGoogleMapsPlaceUrl(
  address: string | null | undefined,
  latitude?: number | null,
  longitude?: number | null,
): string {
  if (isUnknownLocationValue(address)) return "#"
  if (isValidLatLngPair(latitude, longitude)) {
    const nLat = typeof latitude === "string" ? parseFloat(latitude) : Number(latitude)
    const nLng = typeof longitude === "string" ? parseFloat(longitude) : Number(longitude)
    const q = `${nLat},${nLng}`
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`
  }
  const trimmed = address?.trim()
  if (!trimmed) return "#"
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(trimmed)}`
}
